export default ({
  scream = false,
  logoOnly = false,
  logoSize = 'lg',
  look = 'left', // left | right
  onClick = () => {},
}) => {
  const iconFilename = look === 'left' ? 'icon' : 'icon_flipped';
  let logoClasses;
  let iconClasses;
  if (logoOnly) {
    switch (logoSize) {
      case 'xs':
      case 'sm':
        iconClasses = 'w-16';
        break;
      case 'md':
        iconClasses = 'w-20';
        break;
      case 'lg':
      default:
        iconClasses = 'w-24';
        break;
    }
  } else {
    switch (logoSize) {
      case 'xs':
        iconClasses = 'w-12 -mr-2';
        logoClasses = 'w-32 mx-auto -mt-3';
        break;
      case 'sm':
        iconClasses = 'w-16 -mr-2';
        logoClasses = 'w-48 mx-auto -mt-5';
        break;
      case 'md':
        iconClasses = 'w-20 -mr-2';
        logoClasses = 'w-56 mx-auto -mt-6';
        break;
      case 'lg':
      default:
        iconClasses = 'w-24 -mr-2';
        logoClasses = 'mx-auto -mt-8 w-72';
        break;
    }
  }
  return (
    <div
      className={`flex flex-col items-center justify-center`}
      style={{ width: 'max-content' }}
      onClick={onClick}
    >
      <img
        className={iconClasses}
        src={`/static/img/${iconFilename}${scream ? '_scream' : ''}.png`}
      />
      {!logoOnly && <img className={logoClasses} src="/static/img/logo.png" />}
    </div>
  );
};
